import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { environment } from '@envs/environment'
import { AuthService } from '@core/service/auth.service'

@Component({
    selector: 'dashboard-overview',
    templateUrl: './dashboard-overview.component.html',
    styleUrls: ['./dashboard-overview.component.scss'],
})
export class DashboardOverviewComponent {

    constructor(private envService: EnvService, private authService: AuthService) {
    }

    public get baseJsUrl(): string {
      return `${this.envService.baseJsUrl}/dashboard/quantity?host=${environment.baseHost}&childCompany=${this.authService.loggedInUser?.company.id}`;
    }
}
